import React, { useEffect, useRef } from "react";
import Link from "helpers/link";
import loadScript from "helpers/load-script";
import ShopperApproveCard from "@root/components/shopper-approve-card";
import GoogleReviewsCard from "@root/components/google-reviews-card";

const StoreReviews = ({ data, className }) => {
    const widgetRef = useRef(null);

    useEffect(() => {
        window.sa_review_count = data?.number || 5;

        if (window.Trustpilot) {
            // Script already loaded (SPA navigation) — manually re-initialize
            window.Trustpilot.loadFromElement(widgetRef.current, true);
        } else {
            loadScript("//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js");
        }
    }, []);

    return (
        <div>
            <div className="reviews__shopify ">
                <div className="reviews__shopify-header">
                    <img src="https://cdn.shopify.com/s/files/1/0168/9760/5686/files/gg_1.png?v=1781277399" className="reviews__shopify-header-icon" />
                    <h3 className="reviews__shopify-header-title">Trusted by 1M+ Customers</h3>
                </div>
                <p className="reviews__shopify-description">We’re proud to be recognized across the most respected review platforms.</p>
            </div>
            <div className="reviews__platform-cards">
                <ShopperApproveCard />
                <GoogleReviewsCard />
            </div>
            <div className="store-reviews container">
                <div
                    ref={widgetRef}
                    className="trustpilot-widget"
                    data-locale="en-US"
                    data-template-id="539ad60defb9600b94d7df2c"
                    data-businessunit-id="5e70ccbcbc92ef000172fe1b"
                    data-style-height="700px"
                    data-style-width="100%"
                    data-token="ce7238bc-bcb5-4d5b-b8b5-0e5d99d54010"
                    data-stars="4,5"
                    data-review-languages="en"
                >
                    <a href="https://www.trustpilot.com/review/sealskincovers.com" target="_blank" rel="noopener">Trustpilot</a>
                </div>
            </div>
        </div>

    );
};

export default StoreReviews;
